import Tilt from 'react-parallax-tilt';
import {motion} from 'framer-motion';
import {useUiEffects} from '../../hooks/useUiEffects';
import {ImageLoader} from "./ImageLoader";

const InnerCard = ({imageSrc, title, actions, children, mediaSiblings, href, className}) => (
    <div
        className={`card w-full !h-full bg-white text-base-content shadow-sm hover:shadow-xl transition-all duration-300 border border-base-200 rounded-2xl overflow-hidden flex flex-col ${className}`}>
        {href ? (
            <a
                href={href}
                aria-label={title || 'Open'}
                className="absolute inset-0 z-10 rounded-2xl focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/50"
            />
        ) : null}
        <div className="relative flex-none h-64 bg-white p-4">
            <figure className="w-full h-full overflow-hidden flex items-center justify-center">
                <ImageLoader
                    src={imageSrc}
                    alt={title || 'media'}
                    decoding="async"
                    className="max-w-full max-h-full object-contain hover:scale-105 transition-transform duration-500"
                    skeletonClassName="w-full h-full"
                />
            </figure>
            {mediaSiblings ? (
                <div className="absolute bottom-4 left-4 flex flex-col items-start gap-2">{mediaSiblings}</div>
            ) : null}
        </div>

        <div className="card-body p-5 flex-1 flex flex-col">
            {title ?
                <div className="card-title text-lg font-bold leading-tight epi-title-2line mb-2">{title}</div> : null}
            {children}

            <div
                className="card-actions mt-auto z-11 border-t border-base-100 pt-4 flex justify-between items-center">{actions}</div>
        </div>
    </div>
);

export const Card = ({imageSrc, actions, children, title = null, mediaSiblings = null, href = "", className = ''}) => {
    const effects = useUiEffects();
    const props = {imageSrc, title, mediaSiblings, actions, children, href, className};
    const inner = <InnerCard {...props} />;

    if (!effects.motion && !effects.tilt) return inner;

    const content = effects.motion ? (
        <motion.div className="h-full" initial={{opacity: 0, y: 10}} whileInView={{opacity: 1, y: 0}}
                    viewport={{once: true}} transition={{duration: 0.3}}>
            {inner}
        </motion.div>
    ) : inner;

    return effects.tilt ? (
        <Tilt className="h-full" glareEnable={false} tiltMaxAngleX={6} tiltMaxAngleY={6} scale={1.01}>{content}</Tilt>
    ) : content;
};